import { Logo } from 'components';

// eslint-disable-next-line import/no-anonymous-default-export
export const Loading = () => (
  <div className="z-50 fixed top-0 left-0 w-full h-screen bg-white flex items-center justify-center">
    <Logo className="w-96" />
  </div>
);
